import Button from "components/Button";
import { InfieldPositions, OutfieldPositions, PitcherPositions } from "types/Player";
import { useMemo } from "react";
import { StepProps } from "../Form";
import FormNav from "../FormNav";
import FormStyles from "../styled";

const ChoosePosition = (props: StepProps) => {
  const _onClick = (type: string) => {
    props.onClick(type);

    if (props.nextStep) {
      props.nextStep();
    }
  };

  const positions = useMemo(() => {
    if (props.type === "batter") {
      return [...Object.keys(InfieldPositions), ...Object.keys(OutfieldPositions)];
    } else {
      return Object.keys(PitcherPositions);
    }
  }, [props.type]);

  return (
    <FormStyles.Step>
      <FormStyles.StepContent>
        <FormStyles.ButtonsGroup>
          <p>Choose the player's position:</p>

          <Button onClick={_onClick.bind(null, "any")} key={"any"} active={props.position === "any"}>
            Any
          </Button>

          {positions.map((position) => (
            <Button onClick={_onClick.bind(null, position)} key={position} active={props.position === position}>
              {position}
            </Button>
          ))}
        </FormStyles.ButtonsGroup>
      </FormStyles.StepContent>
      <FormNav {...props} />
    </FormStyles.Step>
  );
};

export default ChoosePosition;
